import axiosApi from './util'

export default {
  listImages () {
    return axiosApi.get('/admin/image')
      .then(response => {
        return response.data
      })
  },
}